import React, { useState, useEffect } from "react";
import { Popconfirm, Icon, Card, Row, Col, Tag, Tooltip, message, Spin, Button, Pagination } from "antd";
import moment from "moment";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderFigureDataNuevo from "../../components/render-figure-data";

import Colors from "../../theme/colors";

import { figurenames, webEntity } from "../../constants";

// pages
import Articulo from "../articulo";

// Hooks
import useArticles from "../../hooks/useArticles";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from "react-i18next";

import { GET_ARTICLES } from "../../operations/queries/articles";

import { useQuery } from "@apollo/react-hooks";

const ListArticles = ({ changeTitle }) => {
  const [edit, setEdit] = useState(false);
  const [editDesingEl, setEditDesingEl] = useState({});

  const { articleData, deleteArticle } = useArticles();

  //prueba
  const [listOfArticles, setListOfArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const { loading, data, refetch } = useQuery(GET_ARTICLES(webEntity), {
    notifyOnNetworkStatusChange: true,
  });

  const [rowsEachPage, setRowsEachPage] = useState(10);

  //if (networkStatus === 4) console.log("Refetching!");
  //if (loading) console.log("loaging");
  //if (error) console.log(`Error! ${error}`);

  //To translate text
  const { t } = useTranslation();

  //const history = useHistory();

  //hange title
  useEffect(() => {
    changeTitle && !edit && changeTitle("articles");
  }, [changeTitle, edit]);

  useEffect(() => {
    console.log(selectedArticle, selectedRowKey);
  }, [selectedArticle, selectedRowKey]);

  //Refresh where data exist (on return to page)
  useEffect(() => {
    if (data) refetch();
    const rows_each_page = JSON.parse(localStorage.getItem("rows_each_page_articles"));
    if (rows_each_page) setRowsEachPage(rows_each_page);
  }, []);

  //hange title
  useEffect(() => {
    if (data && data.articles) {
      setListOfArticles(data.articles);
      data.articles[0] && getDataOnRow(data.articles[0]);
    }
  }, [data]);

  //De momento no lo uso
  /*useEffect(() => {
    async function fetchData() {
      const response = await articles();
      const normalized = response.map((article) => {
        return {
          //key: article.id_article,
          ...article,
        };
      });
      if (normalized && normalized[0]) {
        setListOfArticles(normalized);
        getDataOnRow(normalized[0]);
      }
    }
    //fetchData();
  }, []);*/

  const editDesing = (record) => {
    changeTitle("edit_article", record.name);
    setEditDesingEl({
      id: record.id_article,
      type: "edit",
    });
    setEdit(!edit);
  };

  //Delete one article
  const removeArticle = (id) => {
    async function remArticle(id) {
      const response = await deleteArticle(id, webEntity);
      if (response) {
        message.success(t("alerts.article_removed"));

        //Filter local articles
        let newArticulillos = listOfArticles.filter((d) => d.id_article !== id);
        setListOfArticles(newArticulillos);

        //Select preview article if exist
        if (newArticulillos && newArticulillos.length > 0) getDataOnRow(newArticulillos[newArticulillos.length - 1]);

        //refetch(); Intrusive option
      } else {
        message.error(t("alerts.article_not_removed"));
      }
    }
    remArticle(id);
  };

  const cloneDesing = (record) => {
    changeTitle("clone_article", record.name);
    setEditDesingEl({
      id: record.id_article,
      type: "clone",
    });
    setEdit(!edit);
  };

  const columnsGraph = [
    {
      title: t("table.header.name"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.geometry"),
      dataIndex: "id_article_type.name",
      key: "id_article_type.name",
      sorter: (a, b) => a.id_article_type.name.localeCompare(b.id_article_type.name),
      //...Search("selected_figure"),
      filters: [
        { text: t("geometry.cylinder"), value: "cylinder" },
        { text: t("geometry.rhomboid"), value: "rhomboid" },
        { text: t("geometry.torus"), value: "torus" },
        { text: t("geometry.rectangle"), value: "rectangle" },
      ],
      onFilter: (value, record) => record.id_article_type.name.toLowerCase().includes(value),
      render: (value) => {
        if (value) return t("geometry." + value.toLowerCase());
        else return "";
      },
    },
    {
      title: t("table.header.type"),
      dataIndex: "is_prototype",
      key: "is_prototype",
      width: 100,
      render: (isPrototype) => (isPrototype ? t("labels.prototype") : t("labels.catalogue")),
      filters: [
        { text: t("labels.prototype"), value: true },
        { text: t("labels.catalogue"), value: false },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.is_prototype === value,
    },
    {
      title: t("table.header.article_date"),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: t("table.header.actions"),
      key: "action",
      width: 140,
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip title={t("button.action.clone", { value: record.name })}>
            <Button type="link" onClick={() => cloneDesing(record)} style={{ padding: 0 }}>
              <Icon type="diff" />
            </Button>
          </Tooltip>
          <Tooltip title={record.in_use ? t("button.action.associated_design") : t("button.action.edit", { value: record.name })}>
            <Button type="link" onClick={() => !record.in_use && editDesing(record)} style={{ color: record.in_use && "#ccc", padding: 0 }}>
              <Icon type="edit" />
            </Button>
          </Tooltip>
          <Popconfirm
            disabled={record.in_use}
            title={t("button.confirm.delete_article", { value: record.name })}
            okText={t("button.confirm.yes")}
            onConfirm={() => removeArticle(record.id_article)}
            cancelText={t("button.confirm.no")}
            icon={<Icon type="question-circle-o" style={{ color: Colors.danger }} />}
          >
            <Tooltip title={record.in_use ? t("button.action.associated_design") : t("button.action.delete", { value: record.name })}>
              <Button type="link" style={{ color: record.in_use ? "#ccc" : Colors.danger, padding: 0 }}>
                <Icon type="delete" />
              </Button>
            </Tooltip>
          </Popconfirm>
        </Row>
      ),
    },
  ];

  // rowSelection objects indicates the need for row selection
  const rowSelectionNew = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      getDataOnRow(record);
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      //console.log(selected, selectedRows, changeRows);
    },
    type: "radio",
  };

  //const goForward = () => history.goForward();

  const editClose = () => {
    setEdit(false);
    //refetch();
  };

  const addNewRowOnClone = (art, type) => {
    //setEdit(false);
    //Filter local articles
    if (type === "clone") {
      let newArticulillos = listOfArticles.concat(art);
      setListOfArticles(newArticulillos);
      //Select preview article if exist
      if (newArticulillos && newArticulillos.length > 0) getDataOnRow(newArticulillos[newArticulillos.length - 1]);
    }

    if (type === "update") {
      let editArticulillos = listOfArticles.map((d) => {
        let edited = { ...art };
        edited.date = d.date;
        edited.in_use = d.in_use;
        return d.id_article === art.id_article ? edited : d;
      });
      setListOfArticles(editArticulillos);
    }
  };

  const clickRowNew = (row, b) => {
    getDataOnRow(row);
  };

  //Selected row
  async function getDataOnRow(row) {
    const response = await articleData(row.id_article);
    if (!response) return;
    let article_type = row.id_article_type?.name.toLowerCase() || "cylinder";

    let figure = {
      name: article_type,
    };

    let values = {};
    figurenames[article_type].forEach((data) => {
      let prop = response.find((el) => el.tag.trim() === data.key);
      values[data.key] = prop && prop.value && parseInt(prop.value);
    });

    response.forEach((el) => {
      if (!values[el.tag.trim()]) {
        row[el.tag.trim()] = parseInt(el.value);
      }
    });

    figure.values = values;
    row.figure = figure;

    setSelectedRowKey([row.id_article]);
    setSelectedArticle(row);
  }

  return edit ? (
    <Articulo /*desing={editDesingEl}*/ back={true} close={editClose} editOrClone={editDesingEl} addNewRowOnClone={addNewRowOnClone} />
  ) : (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Spin spinning={loading}>
        <Col xl={16} lg={24}>
          <Table
            rowKey="id_article"
            data={listOfArticles}
            columns={columnsGraph}
            rowSelection={rowSelectionNew}
            onClick={() => clickRowNew}
            pagination={{
              pageSize: rowsEachPage,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "50"],
              onShowSizeChange: (_, pageSize) => {
                localStorage.setItem("rows_each_page_articles", pageSize);
                setRowsEachPage(pageSize);
              },
            }}
          />
        </Col>
        <Col xl={8} lg={24}>
          <Card
            title={selectedArticle && selectedArticle.name}
            extra={
              selectedArticle && selectedArticle.is_prototype ? (
                <Tag color="magenta">{t("labels.prototype")}</Tag>
              ) : (
                <Tag color="blue">{t("labels.catalogue")}</Tag>
              )
            }
            cover={
              selectedArticle && (
                <ThreeBox>
                  <ThreeFigure figureData={selectedArticle && selectedArticle.figure} />
                </ThreeBox>
              )
            }
          >
            <RenderFigureDataNuevo selectedArticle={selectedArticle} />
          </Card>
        </Col>
      </Spin>
    </Row>
  );
};

export default ListArticles;
